<template>
  <div v-if="subsection">
    <div v-if="!isEditMode">
      <h5 v-if="subsection.title" v-html="subsection.title"></h5>
    </div>
    <div v-else>
      <h4>Заголовок</h4>
      <b-form-input
        :value="subsection.title"
        placeholder="Введите название"
        @input="$_subsectionMixin_onTitleChange" />
      <div class="text-center mx-auto my-2">
        <b-button variant="outline-primary" @click="addModel">
          <div v-if="!subsection.file">
            <em class="fa fa-plus mr-1"></em> Добавить модель
          </div>
          <div v-else>
            <em class="fas fa-pen mr-1"></em> Изменить модель
          </div>
        </b-button>
      </div>
      <v-modal-files-upload wrkspcType="3d"></v-modal-files-upload>
    </div>
    <div v-if="subsection.file">
      <b-button variant="primary" class="mb-2" @click="hideMenuModel">
        {{isMenuModelShow ? 'Скрыть меню' : 'Показать меню'}}
      </b-button>
      <b-card class="position-absolute model-menu-card" v-if="isMenuModelShow">
        <b-form-group label="Режим нажатия">
          <b-form-radio v-model="typeOfClick" name="radios-type-click"
                        value="Скрытие">Скрытие</b-form-radio>
          <b-form-radio v-model="typeOfClick" name="radios-type-click"
                        value="Выбор">Выбор</b-form-radio>
          <b-form-radio v-model="typeOfClick" name="radios-type-click"
                        value="Просмотр">Просмотр</b-form-radio>
        </b-form-group>
        <b-button variant="primary" class="model-menu-card-button"
            @click="unSelectAllElements" v-b-tooltip.hover
            title="При нажатии все выбранные элементы перестанут быть выбранными">
          Снять выбор</b-button>
        <b-button class="mt-1 model-menu-card-button" variant="primary"
            @click="showAllElements" v-b-tooltip.hover
            title="При нажатии все скрытые элементы будут снова отображены">
          Показать все</b-button>
      </b-card>
      <model-obj :src="'/api/files/' + subsection.file.physicalName"
                 v-show="modelLoaded"
                 @on-load="onModelLoad"
                 @on-progress="onModelUpdated"
                 class="model-3d-canvas text-center" @on-click="onSelectFigure"></model-obj>
      <div v-show="!modelLoaded" class="text-center">
        <div class="mb-2">Идёт загрузка модели...</div>
        <b-spinner style="width: 30vh; height: 30vh;" variant="primary"></b-spinner>
      </div>
    </div>
    <div v-if="!isEditMode">
      <div class="text-center my-3" v-if="!isTestReviewMode">
        <b-button variant="primary" @click="sendAnswers">
          {{isTriedToAnswer ? 'Ответить ещё раз' : 'Ответить'}}
        </b-button>
      </div>
      <div v-else>
        <h5>Ответ ученика</h5>
        <b-form-input disabled :value="studentAnswer"
          v-b-tooltip.hover title="Порядок не имеет значения."
        ></b-form-input>
        <h5 class="mt-2">Правильный ответ</h5>
        <b-form-input disabled :value="correctAnswer"
          v-b-tooltip.hover title="Порядок не имеет значения."
        ></b-form-input>
      </div>
      <div class="mt-3" v-html="editedText"></div>
    </div>
    <div v-else>
      <h4>Ответы</h4>
      <b-input-group v-b-tooltip.hover
       title="Выберите нужные фигуры на модели, затем нажмите на кнопку 'Обновить ответ'.">
        <b-form-input id="answers-for-model" disabled
        :value="(subsection.qstruct) ? subsection.qstruct.answer : ''"
        placeholder="Выберите нужные фигуры на модели, затем нажмите на кнопку 'Обновить ответ'."/>
        <b-input-group-append>
          <b-button variant="primary" @click="onAnswersChange">Обновить ответ</b-button>
        </b-input-group-append>
      </b-input-group>
      <h4 class="mt-3">Текст</h4>
      <wysiwyg-text-editor dataType="subSectionText" />
    </div>
  </div>
</template>

<script>
import { ModelObj } from 'vue-3d-model'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import WysiwygTextEditor from '@/components/content/edit/WysiwygTextEditor.vue'

import ContentMixin from '@/components/helpers/mixins/content-mixin'
import SubsectionMixin from '@/components/helpers/mixins/subsection-mixin'

const VModalFilesUpload = () => import('@/components/content/edit/modals/ModalFilesUpload.vue')

export default {
  name: 'ModelTestSubSection',
  components: {
    ModelObj,
    VModalFilesUpload,
    WysiwygTextEditor
  },
  mixins: [ContentMixin, SubsectionMixin],
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.subsectionUpdate()
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  updated() {
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  watch: {
    subsection() {
      this.unSelectAllElements()
      this.isTriedToAnswer = false
      this.showAllElements()
      this.subsectionUpdate()
    },
    isEditMode() {
      this.typeOfClick = 'Просмотр'
    },
    onUpdateModel() {
      if (this.$route.path === this.currentUrl && (this.currentModel
      !== (this.subsection) ? this.subsection.file : null)) {
        this.updateUpdater()
        this.setSubsectionAnswer('')
        document.getElementById('answers-for-model').value = ''
        this.unSelectAllElements()
        this.showAllElements()
      }
      this.currentModel = null
      this.currentUrl = null
      this.noUpdateFiles = !this.noUpdateFiles
      this.$nextTick(() => {
        this.noUpdateFiles = !this.noUpdateFiles
      })
    }
  },
  computed: {
    ...mapGetters({
      subsection: 'education/getSubsection',
      isTestingMode: 'test/isTestingMode',
      test: 'test/getTest',
      progress: 'test/getProgress',
      isTestReviewMode: 'educationStudentsManagement/getTestReviewMode',
      solvedByStudent: 'educationStudentsManagement/getSolvedByStudent'
    }),
    onUpdateModel() {
      return (this.subsection) ? this.subsection.file : null
    }
  },
  data() {
    return {
      selectedFigures: [],
      isTriedToAnswer: false,
      typeOfClick: 'Просмотр',
      hiddenObjects: [],
      isMenuModelShow: false,
      noUpdateFiles: true,
      currentModel: null,
      currentUrl: null,
      modelLoaded: true,
      editedText: '',
      studentAnswer: null,
      correctAnswer: null
    }
  },
  methods: {
    ...mapMutations({
      setSubsectionAnswer: 'education/setSubsectionAnswer'
    }),
    ...mapActions({
      updateUpdater: 'contentManager/updateUpdater',
      sendAnswer: 'education/sendAnswer'
    }),
    subsectionUpdate() {
      this.studentAnswer = null
      this.correctAnswer = null
      if (this.isTestReviewMode) {
        const answer = this.$_subsectionMixin_getAnswerFromData(this.test, this.solvedByStudent) || []
        this.studentAnswer = answer.join(',')
        this.correctAnswer = this.subsection.qstruct.answer
      }
    },
    addModel() {
      this.currentModel = (this.subsection) ? this.subsection.file : null
      this.currentUrl = this.$route.path
      this.$bvModal.show('files-upload-modal')
    },
    onSelectFigure(event) {
      if (!event) {
        return
      }
      if (this.typeOfClick === 'Выбор') {
        if (this.selectedFigures.filter((p) => p[0] === event.object).length) {
          for (let i = 0; i < this.selectedFigures.length; i++) { // eslint-disable-line no-plusplus
            if (this.selectedFigures[i][0] === event.object) {
              event.object.material.color.setStyle(`rgb(${this.selectedFigures[i][1].r * 255}
              ,${this.selectedFigures[i][1].g * 255},${this.selectedFigures[i][1].b * 255})`)
              this.selectedFigures.splice(i, 1)
            }
          }
        } else {
          const defaultColor = { ...event.object.material.color }
          event.object.material.color.setStyle('#0078c1')
          this.selectedFigures.push([event.object, defaultColor])
        }
      } else if (this.typeOfClick === 'Скрытие') {
        this.hiddenObjects.push(event.object)
        event.object.visible = false
      }
    },
    sendAnswers() {
      this.isTriedToAnswer = true
      const figures = []
      for (let i = 0; i < this.selectedFigures.length; i++) {
        figures.push(this.selectedFigures[i][0].name)
      }
      if (!this.isTestingMode) {
        this.sendAnswer({
          courseId: this.$route.params.courseBookId,
          subsectionId: this.$route.params.subsectionId,
          answer: figures,
          type: 'test'
        })
        this.isTriedToAnswer = true
      } else {
        this.$cookies.set(`test_${this.$route.params.sectionId}_${this.$route.params.subsectionId}_model`, JSON.stringify(figures))
        const questions = this.$cookies.keys().filter((k) => k.includes(`test_${this.test.id}`))
        this.$_subsectionMixin_updateSolved(questions)
      }
    },
    unSelectAllElements() {
      for (let i = 0; i < this.selectedFigures.length; i++) {
        this.selectedFigures[i][0].material.color.setStyle(`rgb(${this.selectedFigures[i][1].r * 255}
        ,${this.selectedFigures[i][1].g * 255},${this.selectedFigures[i][1].b * 255})`)
      }
      this.selectedFigures = []
    },
    showAllElements() {
      for (let i = 0; i < this.hiddenObjects.length; i++) {
        this.hiddenObjects[i].visible = true
      }
      this.hiddenObjects = []
    },
    hideMenuModel() {
      this.isMenuModelShow = !this.isMenuModelShow
    },
    onAnswersChange() {
      this.updateUpdater()
      const figures = this.selectedFigures.map((figure) => figure[0].name)
      const answer = figures.join(',')
      this.setSubsectionAnswer(answer)
      document.getElementById('answers-for-model').value = this.subsection.qstruct.answer
    },
    onModelLoad() {
      this.modelLoaded = true
    },
    onModelUpdated() {
      this.modelLoaded = false
    }
  }
}
</script>

<style>
  .model-3d-canvas {
    width: 100%;
  }
  .model-3d-canvas canvas{
    border: 1px solid #0078c1;
    min-height: 40vh;
    max-height: 40vh;
    min-width: 170px;
    max-width: 100%;
  }
  .model-menu-card {
    width:170px;
    border: 1px solid #0078c1;
  }
  .model-menu-card-button {
    font-size: 15px;
  }
</style>
